






































import { computed, defineComponent, PropType, unref } from '@vue/composition-api';
import AppCard from '@berlin-front/common/components/elements/AppCard';
import AppContainer from '@berlin-front/common/components/elements/AppContainer';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppText from '@berlin-front/common/components/elements/AppText';
import ModalHeader from '@berlin-front/common/components/clusters/ModalHeader';
import { ModalHeaderContext } from '@services/ModalHeaderContext';
import { TEXT_COLOR, TEXT_SIZE, TEXT_WEIGHT } from '@berlin-front/common/components/elements/AppText/composable';
import { useContext } from '@berlin-front/common/composables/context';
import { HEADER_TYPE } from '@berlin-front/common/components/clusters/ModalHeader/composable';
import exclamationCircleIcon from '@berlin-front/common/assets/exclamation-circle-icon.svg';
import { AtoneAuthSystemErrorViewContext } from './composable';

export default defineComponent({
  name: 'AuthErrorView',
  components: {
    AppCard,
    AppContainer,
    AppRow,
    AppText,
    ModalHeader,
    HeaderContextConsumer: ModalHeaderContext.consumer,
  },

  props: {
    /**
     * エラーの種別です。
     *
     * 種別によって文言が変わります。
     * メンテナンス時はメンテナンス時刻が動的に提供されます。
     */
    errorType: {
      type: String as PropType<'system' | 'maintainance' | 'shop'>,
      default: 'system',
    },
  },

  setup(props) {
    const { useSystemError } = useContext(AtoneAuthSystemErrorViewContext);
    const { errors, close } = useSystemError();

    const title = computed(() =>
      ({
        system: `            システムエラー
                         (ご利用いただけません)`,

        shop: `           認証できませんでした`,

        maintainance: `     メンテナンス中...
                         (ご利用いただけません)`,
      })[props.errorType].replace(/^\s*/g, ''),
    );
    const instruction = computed(() =>
      ({
        system: `           ご迷惑をお掛けし申し訳ありません。
                              正常に処理ができませんでした。
                         しばらく時間をおいてからご利用ください。`,

        shop: `             ご迷惑をお掛けし申し訳ありません。
                              正常に処理ができませんでした。
                          詳細はご利用店舗にお問い合わせください。`,

        maintainance: `       ${unref(errors) ?? ''}`,
      })[props.errorType].replace(/^\s*/g, ''),
    );
    const titleColor = computed(() => (props.errorType === 'shop' ? TEXT_COLOR.DEFAULT : TEXT_COLOR.ERROR));

    return {
      exclamationCircleIcon,
      title,
      instruction,
      ModalHeader,
      close,

      titleColor,
      TEXT_SIZE,
      TEXT_WEIGHT,
      HEADER_TYPE,
    };
  },
});
